// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-04512783] .v-input input:focus::-moz-placeholder {\n  color: #fff;\n}\n[data-v-04512783] .v-input input:focus::placeholder {\n  color: #fff;\n}\n.v-btn.type-search .v-btn__content[data-v-04512783] {\n  font-size: var(--font22);\n  font-weight: 700;\n}\n.pageInfo2[data-v-04512783] {\n    position: relative;\n    right: 0;\n    font-size: var(--font16);\n    color: #808495;\n    line-height: 1;\n    text-align: right;\n    bottom: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
